import { Configuration, OrdersApi } from '@/api';
import MenuButton from '@/components/MenuButton';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { DocumentArrowDownIcon } from '@heroicons/react/24/outline';

interface ExportCurrentOrderButtonProps {
  orderId: string;
  initialFormat?: 'csv' | 'xlsx';
}

const exportFormats = [
  { label: 'CSV', value: 'csv' },
  { label: 'Excel', value: 'xlsx' },
];

const ExportCurrentOrderButton = ({ orderId }: ExportCurrentOrderButtonProps) => {
  const auth = useAuth();
  const ordersApi = new OrdersApi(new Configuration(auth));

  const downloadFile = (blob: Blob, filename: string) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleExport = async (selectedFormat: 'csv' | 'xlsx') => {
    try {
      const blob = await ordersApi.exportOrders(
        null,
        undefined,
        [orderId],
        undefined,
        undefined,
        selectedFormat,
      );

      const fileExtension = selectedFormat === 'xlsx' ? 'xlsx' : 'csv';
      const filename = `order-${orderId}-${Date.now()}.${fileExtension}`;
      downloadFile(blob, filename);
    } catch (error) {
      console.error('Failed to export order:', error);
    }
  };

  return (
    <MenuButton
      data-testid="order-details-export-button"
      label="Export"
      icon={<DocumentArrowDownIcon className="w-5 h-5 mr-1" />}
      options={exportFormats}
      onClick={(option) => {
        option.value === 'csv' || option.value === 'xlsx' ? handleExport(option.value) : false;
      }}
    />
  );
};

export default ExportCurrentOrderButton;
